module.exports = __webpack_public_path__ + "images/assets/fc9ac51e128d131f57b365ffb527506c.svg";